import styled from 'styled-components';

const CardFilterStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
  
  * {
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
  }

  .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #7367f0 0%, #5a4fcf 100%);
    color: #ffffff;
    border-radius: 20px;
    margin: 4px 6px;
    height: 36px;
    padding: 6px 14px;
    min-width: 100px;
    width: auto;
    max-width: 220px;
    box-shadow: 0 2px 8px rgba(115, 103, 240, 0.25);
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(115, 103, 240, 0.35);
    }
  }

  .card-text {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
  }

  .card-text p {
    margin: 0;
  }

  .card-close {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }

  .card-close button {
    color: #ffffff;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }

    &:focus,
    &:active,
    &:active:focus {
      outline: none;
    }
  }

  .card-close span {
    font-size: 14px;
  }
`;
export default CardFilterStyle
